import request from '@/utils/request'

// 统一请求：服务码 admin.getStaffCommunityFeeSummary
function requestStaffSummary(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.getStaffCommunityFeeSummary',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取员工小区费用汇总数据失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 按员工汇总其名下小区的收费率等指标
export function getStaffCommunityFeeSummary(params) {
  return requestStaffSummary(params)
}

// 按员工查询其名下每个小区的费用总额（每小区一条）
export function getStaffCommunitySummary(params) {
  return requestStaffSummary({ ...params, detail: 1 })
}

// 查询指定小区内各费用项的收费明细（应收/实收/欠费）
export function getCommunityFeeDetail(params) {
  return requestStaffSummary({ ...params, detail: 2 })
}
